import { render, staticRenderFns } from "./ModalAlterarDevedor.vue?vue&type=template&id=68d6b9b8&scoped=true&"
import script from "./ModalAlterarDevedor.vue?vue&type=script&lang=js&"
export * from "./ModalAlterarDevedor.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlterarDevedor.vue?vue&type=style&index=0&id=68d6b9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6b9b8",
  null
  
)

export default component.exports